import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Modal from "../common/Modal/Modal";
import {useSubmitGuard} from "../common/Helpers";
import {getCompanyPojects} from "../../actions/projects";
import {convertQuote} from "../../actions/quote";

// The Basic-tier half of Quote conversion (see GitHub #624/#632/#633) -- picks an existing
// Project to attach the resulting Contract to, mirroring ContractCreateModal.js's
// existing-project selector. Creating a brand-new project inline isn't supported here yet
// (addProject doesn't return a promise the way this modal's flow needs -- see
// ContractCreateModal.js's useEffect-based workaround for why); a company with no project yet
// can create one from Project Management first, then come back to convert.
export function QuoteConvertModal(props) {

    const company_projects = useSelector((state) => state.projects.company_projects);
    const [pid, setPid] = useState("");
    const {isSubmitting, guardedSubmit} = useSubmitGuard();
    const history = useHistory();

    useEffect(() => {
        props.getCompanyPojects();
    }, []);

    const handleSubmit = guardedSubmit((e) => {
        e.preventDefault();
        return props.convertQuote(props.quoteId, pid).then((res) => {
            if (res && res.data && !res.data.error) {
                history.push(`/mng/workflow/view/${res.data.contract_id}`);
            }
        });
    });

    return (
        <Modal blurBack={true} hasCloseButton={true} hideLogo handleClose={() => props.setModalOpen(false)}>
            <div className="flex-column w100">
                <form onSubmit={handleSubmit} className="form">
                    <h3 className="title2 gap-below-m heavy t-center">Convert to Contract</h3>

                    {company_projects && company_projects.length > 0 ? (
                        <div className="inputs-wrapper gap-below-m">
                            <div className="input-basic">
                                <select name="project_id" id="convert_project_id" value={pid} onChange={(e) => setPid(e.target.value)} required>
                                    <option value="">Select a project</option>
                                    {company_projects.map((project) => (
                                        <option key={project.project_id} value={project.project_id}>{project.project_name}</option>
                                    ))}
                                </select>
                                <label htmlFor="convert_project_id">Attach to Project <span>*</span></label>
                            </div>
                        </div>
                    ) : (
                        <p className="content2 light-black gap-below-m">You don't have a project to attach this to yet. Create one from Project Management first, then come back to convert this Quote.</p>
                    )}

                    <div className="flex-row">
                        <button className="btn pri expand gap-right-xs" type="submit" disabled={!pid || isSubmitting}>{isSubmitting ? "Converting..." : "Convert"}</button>
                        <button
                            className="btn sec expand"
                            onClick={(e) => {
                                e.preventDefault();
                                props.setModalOpen(false);
                            }}>Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {getCompanyPojects, convertQuote})(QuoteConvertModal);
